/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

require("@fontsource/montserrat/400.css")
require("@fontsource/montserrat/500.css")
require("@fontsource/montserrat/600.css")
require("@fontsource/montserrat/700.css")
require("@fontsource/montserrat/800.css")

require('./src/styles/global.css')

const SCROLL_DURATION = 300
const NAV_OFFSET = 80

function scrollToHash(hash) {
  const id = hash.replace(/^#/, '')
  if (!id) return

  const el = document.getElementById(id)
  if (!el) return

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    window.scrollTo(0, el.getBoundingClientRect().top + window.scrollY - NAV_OFFSET)
    return
  }

  const target = el.getBoundingClientRect().top + window.scrollY - NAV_OFFSET
  const start = window.scrollY
  const distance = target - start
  const startTime = performance.now()

  const step = (now) => {
    const t = Math.min((now - startTime) / SCROLL_DURATION, 1)
    const eased = 1 - (1 - t) ** 3
    window.scrollTo(0, start + distance * eased)
    if (t < 1) requestAnimationFrame(step)
  }

  requestAnimationFrame(step)
}

function handleAnchorClick(event) {
  const link = event.target.closest('a[href^="#"]')
  if (!link) return

  const hash = link.getAttribute('href')
  if (!hash || hash === '#') return

  const id = hash.slice(1)
  if (!document.getElementById(id)) return

  event.preventDefault()
  scrollToHash(hash)
  window.history.pushState(null, '', hash)
}

// Wyrejestruj service worker (i wyczysc cache) u uzytkownikow ktorzy
// mieli poprzednia wersje strony z gatsby-plugin-offline.
// Bez tego service worker dalej serwowalby stary content.
exports.onClientEntry = () => {
  if (typeof navigator === 'undefined') return
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((reg) => reg.unregister())
    }).catch(() => {})
  }
  if (typeof caches !== 'undefined') {
    caches.keys().then((keys) => {
      keys.forEach((key) => caches.delete(key))
    }).catch(() => {})
  }
}

exports.onInitialClientRender = () => {
  document.addEventListener('click', handleAnchorClick)

  if (window.location.hash) {
    requestAnimationFrame(() => scrollToHash(window.location.hash))
  }
}

exports.shouldUpdateScroll = ({ routerProps: { location } }) => {
  if (location.hash) return false
  return [0, 0]
}

exports.onRouteUpdate = ({ location }) => {
  if (location.hash) {
    requestAnimationFrame(() => scrollToHash(location.hash))
  } else {
    window.scrollTo(0, 0)
  }
}
